// Saving to localstorage the current product
function saveFloatingProductToLocalStorage() {
  const floatingProduct = {};

    // ✅ Product ID and handle
  const idEl = document.getElementById('product-id');
  const handleEl = document.getElementById('product-handle');
  floatingProduct.id = idEl ? idEl.value.trim() : '';
  floatingProduct.handle = handleEl ? handleEl.value.trim() : '';

  // ✅ Upsell flags
  const hasMainUpsellEl = document.getElementById('has-main-upsell');
  const hasProductUpsellEl = document.getElementById('has-product-upsell');

  floatingProduct.hasMainUpsell = hasMainUpsellEl
    ? hasMainUpsellEl.value.trim() === 'true'
    : false;

  floatingProduct.hasProductUpsell = hasProductUpsellEl
    ? hasProductUpsellEl.value.trim() === 'true'
    : false;

  // Get the product title
  const titleEl = document.querySelector('.product-title');
  floatingProduct.title = titleEl ? titleEl.textContent.trim() : '';

  // Get the product option/subtitle
  const optionEl = document.querySelector('#floating-product-option .options');
  floatingProduct.option = optionEl ? optionEl.textContent.trim() : '';

  // Get the product price
  const priceEl = document.getElementById('floating-product-price');
  floatingProduct.price = priceEl ? priceEl.textContent.trim() : '';

  // Get the product image
  const imageEl = document.getElementById('floating-product-image');
  floatingProduct.image = imageEl
    ? { src: imageEl.src, alt: imageEl.alt }
    : { src: '', alt: '' };

  // Get the icon class
  const iconEl = document.querySelector('.instock-pulse .icon--pulsing-yellow');
  floatingProduct.iconClass = iconEl ? 'icon--pulsing-yellow' : '';

  // Get the delivery text
  const deliveryEl = document.querySelector('.instock-pulse');
  floatingProduct.deliveryText = deliveryEl ? deliveryEl.textContent.trim() : '';

  // Save to localStorage
  localStorage.setItem('floatingProduct', JSON.stringify(floatingProduct));
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';

      this.bindFloatingButton(); // Floating add to cart
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          /*
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            if (this.submitButton.getAttribute('data-hide-drawer') === 'true') {
              this.cart.renderContents(response, false);
              this.submitButton.textContent = 'Tilføjet';
              this.submitButton.classList.add('added');
            } else {
              this.cart.renderContents(response);
            }
          }
          */


          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;

          // ------------------------------
          // UPSALE REDIRECT LOGIC
          // ------------------------------

          // Always save current product first
          saveFloatingProductToLocalStorage();

          const upsellHandle = this.dataset.upsell;               // main upsell
          const hasUpsell2 = this.dataset.upsell2 === 'true';     // upsell-2 flag

          if (upsellHandle) {
            // Redirect to main upsell
            window.location.href = `/products/${upsellHandle}?view=upsell`;
            return; // stop further processing
          }

          if (hasUpsell2) {
            // Redirect to current product handle with upsell-2 view
            const fp = JSON.parse(localStorage.getItem('floatingProduct') || 'null');
            const currentHandle = fp && fp.handle ? fp.handle : '';
            if (currentHandle) {
              window.location.href = `/products/${currentHandle}?view=upsell-2`;
              return; // stop further processing
            }
          }

          // ------------------------------
          // If neither upsell nor upsell-2, continue with normal cart flow
          // ------------------------------

          // Normal behavior if no upsell assigned
          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            if (this.submitButton.getAttribute('data-hide-drawer') === 'true') {
              this.cart.renderContents(response, false);
              this.submitButton.textContent = 'Tilføjet';
              this.submitButton.classList.add('added');
            } else {
              this.cart.renderContents(response);
            }
          }

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }


    // Floating add to cart
    bindFloatingButton() {
      document.addEventListener("click", (event) => {
        // Check if the floating button was clicked
        const floatingButton = event.target.closest("#floating-buy-button");
        if (!floatingButton) return;

        // Find the actual "Add to Cart" button
        const addToCartButton = this.querySelector('.product-form__submit[name="add"]');

        if (addToCartButton) {
          // Replace button content with spinner
          floatingButton.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          addToCartButton.click(); // Trigger the real button click
        }
      });
    }


  });
}
